export enum CheckboxViews {
  Circle = 'circle',
  Square = 'square',
  Switch = 'switch',
  Default = 'default',
}

export enum CheckboxTypes {
  Checkbox = 'checkbox',
  Radio = 'radio',
}
